import s2_1_5_sect2_img1 from '../../../../assets/images/s2_1_5_sect2_img1.png';
import s2_1_5_sect2_img2 from '../../../../assets/images/s2_1_5_sect2_img2.png';

import s2_1_5_sect3_img1 from '../../../../assets/images/s2_1_5_sect3_img1.png';
import s2_1_5_sect3_img2 from '../../../../assets/images/s2_1_5_sect3_img2.png';

import ProductSlider from '../../common/ProductSlider';
import FixedButton from '../../common/FixedButton';
import GoContact from '../../common/GoContact';

export default function Content() {
  return (
    <>
      <GoContact />

      <div className="s2_1_sect2 pt-10">
        <div className="txt-center mb-4">
          <p className="prt-medium fs-22 fc-005eed  mb-1">특징</p>
          <p className="prt-bold fs-40 fc-black1 lh-13">강력한 성능의 T5,T6</p>
        </div>

        <div className="center">
          <div className="col-flex mb-5">
            <div className="row-flex-center m-col-flex between mb-10">
              <div className="s2_1_1_sect2_item w-48 m-w-100">
                <img src={s2_1_5_sect2_img1} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-45 txt-left">
                <p className="prt-bold fs-40 fc-black1 mb-3">
                  여러대 로봇 공통작업
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  여러 대의 로봇이 동일한 작업 환경에서 강력한 스케줄링 시스템을
                  통해 <br className="m-none t-none" />
                  공동 작업하여 효율성을 높이고 비용을 절감하며 서비스 수준을
                  높여 고객에게 <br className="m-none t-none" />더 스마트한 경험을
                  제공할 수 있습니다.
                </p>
              </div>
            </div>

            <div className="row-flex-center m-col-flex between mb-10 ">
              <div className="s2_1_1_sect2_item w-48 m-w-100 pc-none t-none">
                <img src={s2_1_5_sect2_img2} alt="" />
              </div>

              <div className="s2_1_1_sect2_item w-45 txt-right">
                <p className="prt-bold fs-40 fc-black1 mb-3 lh-14">
                  완전 자율 포지셔닝 및 내비게이션
                </p>
                <p className="prt-regular fs-20 fc-a4 lh-15">
                  Keenon Robotics 자체 개발 SLAM 동기화 포지셔닝 및{' '}
                  <br className="m-none t-none" />
                  매핑 시스템에 힘입어 로봇이 안정적이고 효율적으로 작동할 수
                  있습니다. <br />
                  Keenon에서는 다양한 실내 시나리오를 포괄하는 일련의 마커 및{' '}
                  <br className="m-none t-none" />
                  레이저 SLAM 솔루션을 제공합니다. 또한 최신 스테레오 비전{' '}
                  <br className="m-none t-none" />
                  장애물 회피 기술은 로봇의 정확성을 보장합니다.
                </p>
              </div>
              <div className="s2_1_1_sect2_item w-48 m-w-100 m-none">
                <img src={s2_1_5_sect2_img2} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="sect3  pb-5">
        <div className="txt-center mb-4">
          <p className="prt-medium fs-22 fc-005eed  mb-1">제품 사양</p>
          <p className="prt-bold fs-40 fc-black1 lh-13">
            로봇의 상세 스펙을 확인하세요
          </p>
        </div>
        <div className="center">
          <div className="row-flex m-col-flex t-col-flex">
            <div className="left w-50 col-flex flex-center m-w-100 t-w-100">
              <div className="col-flex flex-center s2_1_5_bottom_img mb-4">
                <img src={s2_1_5_sect3_img1} alt="" />
                <span className="s2_1_5_prd_name_black1 bg-black fc-white prt-bold fs-20 mt-3">
                  T5
                </span>
              </div>
              <div className="s2_1_1_sect3_inner w-80 mb-5">
                <div className="row-flex-center between s2_1_1_sect3_inner_box">
                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">제품무게</p>
                    <p className="prt-bold fs-28 fc-black1">50kg</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">트레이 개수</p>
                    <p className="prt-bold fs-28 fc-black1">4</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">적재 중량</p>
                    <p className="prt-bold fs-28 fc-black1">40kg</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">최소 이동폭</p>
                    <p className="prt-bold fs-28 fc-black1">70cm</p>
                  </div>
                </div>
              </div>
              <div className="col-flex w-70 s2_1_1_sect3_inner2_box ">
                <div className="item ">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      제품크기
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70 lh-15">
                      506 × 502 × 1205mm
                    </p>
                  </div>
                </div>

                <div className="item  ">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      제품 순 중량
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70">50kg</p>
                  </div>
                </div>

                <div className="item ">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      트레이 층 수
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70">4</p>
                  </div>
                </div>

                <div className="item">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      최대 하중
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70">
                      40kg(층당 10kg)
                    </p>
                  </div>
                </div>

                <div className="item">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      통과 가능 <br className="pc-none" />
                      최소 폭
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70">
                      70cm (레이블ver.) / 80cm (레이저ver.)
                    </p>
                  </div>
                </div>

                <div className="item">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      배터리 <br className="pc-none" />
                      지속 시간
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70">
                      12~15시간
                    </p>
                  </div>
                </div>

                <div className="item">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      충전시간
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70">5시간</p>
                  </div>
                </div>

                <div className="item">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      운영체제
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70">
                      Android
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="right w-50 col-flex flex-center m-w-100 t-w-100 ">
              <div className="col-flex flex-center  mb-4 ">
                <div className="s2_1_5_bottom_img2_wrap">
                  <img
                    src={s2_1_5_sect3_img2}
                    alt=""
                    className="s2_1_5_bottom_img2"
                  />
                </div>
                <span
                  className="s2_1_5_prd_name_black1 bg-black fc-white prt-bold fs-20 
                mt-3"
                >
                  T6
                </span>
              </div>
              <div className="s2_1_1_sect3_inner w-80 mb-5">
                <div className="row-flex-center between s2_1_1_sect3_inner_box">
                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">제품무게</p>
                    <p className="prt-bold fs-28 fc-black1">52kg</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">트레이 개수</p>
                    <p className="prt-bold fs-28 fc-black1">4</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">적재 중량</p>
                    <p className="prt-bold fs-28 fc-black1">35kg</p>
                  </div>

                  <div className="item col-flex flex-center gap-10">
                    <p className="prt-regular fs-16 fc-a4">최소 이동폭</p>
                    <p className="prt-bold fs-28 fc-black1">70cm</p>
                  </div>
                </div>
              </div>

              <div className="col-flex w-70 s2_1_1_sect3_inner2_box ">
                <div className="item ">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      제품크기
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70 lh-15">
                      519 × 531 × 1256mm
                    </p>
                  </div>
                </div>

                <div className="item  ">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      제품 순 중량
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70">52 kg</p>
                  </div>
                </div>

                <div className="item ">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      트레이 층 수
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70">4</p>
                  </div>
                </div>

                <div className="item">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      최대 하중
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70">
                     35kg
                    </p>
                  </div>
                </div>

                <div className="item">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      통과 가능 <br className="pc-none" />
                      최소 폭
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70">
                      70cm
                    </p>
                  </div>
                </div>

                <div className="item">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      배터리 <br className="pc-none" />
                      지속 시간
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70">
                      12~15시간
                    </p>
                  </div>
                </div>

                <div className="item">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      충전시간
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70">5시간</p>
                  </div>
                </div>

                <div className="item">
                  <div className="row-flex w-100 between txt-left">
                    <p className="prt-semi-bold fs-18 fc-005eed w-30">
                      운영체제
                    </p>
                    <p className="prt-semi-bold fs-18 fc-black1 w-70">
                      Android
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-center">
            <div class="sub_desc prt-light fs-14 fc-888 txt-left lh-15 w-85">
              *배터리와 관련된 모든 설명은 기타 다양한 요인에 의해 제약되며,
              실제 결과는 다를 수 있습니다.
              <br />
              배터리 충전 횟수는 제한되어 결국 교체가 필요할 수 있습니다. 배터리
              수명과 충전횟수는 사용 및 설정에 따라 다릅니다.
            </div>
          </div>
        </div>
      </div>

      <ProductSlider></ProductSlider>
      <FixedButton></FixedButton>
    </>
  );
}
